<template>
  <!-- 新增v-if="open"為了讓他重啟時刷新狀態 -->
  <div class="modal fade confirm" :class="{ 'is-open': open }">
    <!------------------------ 步驟一start ---------------------------->
    <div class="modal-dialog" v-if="step == '1'">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">選擇客戶(步驟1/2)</h3>
        </div>
        <div class="modal-body px_37">
          <!-- -------------------主要區塊start ----------------------->
          <section class="container search" style="padding: 15px 0px 6px 0px">
            <div class="row">
              <div class="col-12">
                <form class="form">
                  <div class="input-group input-lg">
                    <div class="input">
                      <input
                        type="text"
                        name="Search"
                        id="Search"
                        class="form-control"
                        v-model="keyword"
                        @keydown.enter="doSearch()"
                        placeholder="輸入姓名或身分證字號進行搜尋"
                        alt="ch"
                        style="width: 100%"
                        @input="checkKeyword"
                        @blur="checkKeyword"
                      />
                      <span
                        id="searchclear"
                        v-show="keyword"
                        @click="cleanSearch()"
                        >清除</span
                      >
                    </div>
                    <button
                      class="btn btn-primary btn-icon"
                      type="submit"
                      @click.prevent="doSearch()"
                    >
                      <i class="icon-search i-24"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </section>
          <!-- 預設展示 -->
          <div v-if="isSearch == 'D'">
            <h4 class="mt_15 mb_10">選擇CRM家戶</h4>
            <div class="row" v-if="getAllHouseholderBySalesResult.length != 0">
              <div
                class="col-md-4"
                v-for="(item, i) in getAllHouseholderBySalesResult"
                :key="`group-item-${i}`"
              >
                <div class="card pt_9 px_5 pb_6 mb_10">
                  <el-switch
                    v-model="item.namecovermask"
                    active-color="#5DC46C"
                    @change=changeCoverMask(item)
                    style="float:right;"
                  ></el-switch>
                  <strong v-if="item.namecovermask"
                    class="link text-underline m-0 font-24"
                    @click="toStep2(item)"
                    >{{ truncate(item.name, 12) }}</strong
                  >
                  <strong v-else
                    class="link text-underline m-0 font-24"
                    @click="toStep2(item)"
                    >{{ item.name | getMaskName }}
                  </strong>
                  <div class="d-flex justify-content-end mt_5">
                    <Avatar
                      class="mr-2"
                      :gender="Number(item.sex)"
                      :size="20"
                      :height="20"
                    />
                    <strong>{{
                      (item.age || item.age === 0 ? item.age : "--") + "歲"
                    }}</strong>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="text-center d-flex justify-content-center mt-5"
              colspan="6"
            >
              <div
                :class="{ 'h2w3 mt-4 section-loading': custsOfAgntIsLoading }"
              ></div>
              <h3 class="mb-3 pre-formatted">{{ this.remoteDataMessage }}</h3>
            </div>
          </div>
          <!-- 搜尋展示 -->
          <div v-else-if="isSearch == 'S'" class="mt_15">
            <h4 class="text-green d-flex">
              <span class="pt_8 d-inline-block">搜尋結果</span>
              <a class="btn btn-default px_5 py_5 ml_10" @click="cleanSearch()"
                >返回戶長列表</a
              >
            </h4>
            <div
              class="row mt_10"
              v-if="getFamilyMemberByconditionResult.length != 0"
            >
              <div
                v-for="(item, i) in getFamilyMemberByconditionResult"
                :key="`group-item-${i}`"
              >
                <div
                  class="card pt_9 px_5 pb_6 mb_10 mr_10"
                  style="width: 180px"
                >
                  <h4
                    class="link text-underline m-0 font-24"
                    @click="toStep2(item)"
                  >
                    {{ truncate(item.name, 12) }}
                  </h4>
                  <div class="d-flex justify-content-end mt_6">
                    <Avatar
                      class="mr-2"
                      :gender="Number(item.sex)"
                      :size="20"
                      :height="20"
                    />
                    <strong>{{
                      (item.age || item.age === 0 ? item.age : "--") + "歲"
                    }}</strong>
                  </div>
                  <div class="mt_5" style="height: 43px; word-break: break-all">
                    <span class="font-16 mf-textWrap">{{
                      addFamilyName(item.familynamelist)
                    }}</span>
                  </div>
                  <div class="d-flex justify-content-end mt_5">
                    <strong class="font-16">
                      {{
                        `共${
                          item.familynamelist[0] == "(無成員)"
                            ? item.familynamelist.length
                            : item.familynamelist.length + 1
                        }人`
                      }}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else
              class="text-center d-flex justify-content-center mt-5"
              colspan="6"
            >
              <div
                :class="{ 'h2w3 mt-4 section-loading': custsOfAgntIsLoading }"
              ></div>
              <h3 class="mb-3 pre-formatted mr-5">
                {{ this.remoteDataMessage }}
              </h3>
            </div>
          </div>
          <!-- -------------------主要區塊end ----------------------->
        </div>
      </div>
    </div>
    <!------------------------ 步驟一end ---------------------------->
    <!------------------------ 步驟二 start ---------------------------->
    <div class="modal-dialog" v-if="step == '2'">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">選擇客戶(步驟2/2)</h3>
        </div>
        <div class="modal-body">
          <!-- -------------------步驟二 主要區塊start ----------------------->
          <div class="list" style="margin-bottom: 150px" ref="countHeight">
            <div
              style="border: #bebebe solid 1px"
              class="round_4 col-12 pl-10 mb-2 shadow-sm"
            >
              <tr class="d-flex align-items-center">
                <th class="col-1 d-flex flex-column">
                  <div class="checkbox checkbox-inline mr-0">
                    <input
                      type="checkbox"
                      id="thead"
                      :checked="checkboxStatus"
                      @change="checkboxStatusHandler($event)"
                    />
                    <label for="thead">
                      <span>#</span>
                    </label>
                  </div>
                </th>
                <th class="col-2 d-flex justify-content-center pl_5">
                  <strong class="fw-600 ml-27 d-flex justify-content-left">
                    姓名
                  </strong>
                </th>
                <th class="d-flex justify-content-left col-1">
                  <strong class="fw-600"> 身份 </strong>
                </th>
                <th class="col-2 d-flex justify-content-center">
                  <strong class="fw-600 d-flex justify-content-center"
                    >身分證</strong
                  >
                </th>
                <th class="col-2 d-flex flex-column">
                  <strong class="fw-600 d-flex justify-content-center">
                    生日
                  </strong>
                </th>
                <th class="col-1 d-flex flex-column">
                  <strong class="w-center fw-600">年齡</strong>
                </th>
                <th class="col-3 d-flex flex-column">
                  <strong class="w-600 d-flex justify-content-left"
                    >提醒</strong
                  >
                </th>
              </tr>
            </div>

            <template v-for="(item, i) in getAllFamilyResult">
              <div
                :key="`group-item-${i}`"
                style="border: #bebebe solid 1px"
                class="round_4 col-12 pl-10 pt-2 pb-2 shadow-sm mb-2"
              >
                <tr class="d-flex align-items-center">
                  <th class="col-1 d-flex flex-column">
                    <div class="checkbox checkbox-inline mr-0 block-heigh">
                      <input
                        style
                        :id="`customer-${i}`"
                        :value="item.csidno"
                        type="checkbox"
                        v-model="item.check"
                        @change="getAllFamilyResult = [...getAllFamilyResult]"
                      />
                      <label :for="`customer-${i}`">
                        <span class="text-nowrap">{{ i + 1 }}</span>
                      </label>
                    </div>
                  </th>
                  <th class="col-2 d-flex flex-column pl_13">
                    <div class="d-flex align-items-center">
                      <div class="mr_2">
                        <div>
                          <Avatar :gender="Number(item.sex)" :size="20" />
                        </div>
                      </div>

                      <!-- hover身分證、生日 -->
                      <Tooltip
                        position="top"
                        :id="item.csidno.indexOf('~') > -1 ? '' : item.csidno"
                        :birthday="formatDate(item.birthday)"
                      >
                        <div
                          class="font-20 breakLine text-left text-underline mf-textWrap"
                        >
                          <a
                            v-on:click="routeToCustDetail(item.csidno)"
                            class="link text-underline">
                            {{ truncate(item.name, 12) }}
                          </a>
                        </div>
                      </Tooltip>
                    </div>
                  </th>
                  <th class="d-flex flex-column col-1">
                    <div class="d-flex justify-content-center">
                      {{ familyrlList[item.familyrl] }}
                    </div>
                  </th>
                  <th class="col-2 d-flex flex-column">
                    <div :class="'d-flex justify-content-center'">
                      {{
                        item.csidno.includes("~")
                          ? "一 一"
                          : item.csidno
                          ? item.csidno
                          : "一 一" | getMaskID
                      }}
                    </div>
                  </th>
                  <th class="d-flex flex-column col-2">
                    <div class="d-flex justify-content-center">
                      {{
                        item.birthday
                          ? formatDate(item.birthday)
                          : "一 一" | getMaskBirthday
                      }}
                    </div>
                  </th>
                  <th class="col-1 d-flex flex-column">
                    <div>
                      {{ item.age || item.age === 0 ? item.age : "一 一" }}
                    </div>
                  </th>
                  <th class="col-3 d-flex ml-4">
                    <div class="mr-28 text-left mf-textWrap">
                      <div>{{ item.notify }}</div>
                      <template v-if="item.memochk === 'Y'">
                        <span>本客戶尚有房貸拍賣不足餘額未清償</span>
                        (
                        <span
                          class="custGreen btn p-0 m-0"
                          @click="panelOpen('mvInfoOpen')"
                          >說明</span
                        >
                        )
                      </template>
                    </div>
                  </th>
                </tr>
              </div>
            </template>
          </div>
          <div class="action text-right">
            <button type="submit" class="btn btn-default" @click="toStep1()">
              重選家戶
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              @click="toImport()"
              :disabled="!getAllFamilyResult.some((item) => item.check)"
            >
              確定匯入
            </button>
          </div>
          <!-- -------------------步驟二 主要區塊end ----------------------->
        </div>
      </div>
    </div>
    <!------------------------ 步驟二 end ---------------------------->
  </div>
</template>

<script>
import {
  getFamilyMemberBycondition,
  getFamilyMemberByConditionBnk,
  getAllHouseholderBySales,
  getFamilyMemberByCsidNo,
  getAllFamily,
} from "@/service";
import Avatar from "@/desktop/components/Avatar";
// import mock__getAllHouseholderBySales from "@/desktop/views/mf/mock/getAllHouseholderBySales.json";
// import mock__getFamilyMemberBycondition from "@/desktop/views/mf/mock/getFamilyMemberBycondition.json";
// import mock__getAllFamily from "@/desktop/views/mf/mock/getAllFamily.json";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import mf_Mixin from "@/desktop/views/mf/mixin";
import Tooltip from "@/desktop/components/ToolTip";
export default {
  name: "CustomerPopup",
  mixins: [mf_Mixin],
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    customizeList: [Object],
  },
  components: { Avatar, Tooltip },

  data() {
    return {
      step: "1",
      // ----------步驟一-------------------------
      isSearch: "D", //判斷頁面與Button( D為展示預設，S為搜尋結果)
      keyword: "", //搜尋條件
      remoteDataMessage: "'資料讀取中，請稍候...", //遠端資料訊息
      custsOfAgntIsLoading: false, //是否在搜尋中
      getAllHouseholderBySalesResult: [], //戶長列表
      getFamilyMemberByconditionResult: [], //搜尋結果
      // ----------步驟二-------------------------
      //MOUNTED搜尋回傳結果
      getAllFamilyResult: [],
      familyrlList: ["戶長", "配偶", "子女", "父母", "其他", "孫子女"],
    };
  },
  computed: {
    ...mapGetters(["CustInfo", "UserInfo"]),
    //步驟二的全選checkbox
    checkboxStatus() {
      return this.getAllFamilyResult.every((item) => {
        return item.check;
      });
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["updateAllHolderSearchData", "updateQueryKeyword"]),
    checkKeyword() {
      this.keyword = this.checkSpecialKeyword(this.keyword);
    },
    checkboxStatusHandler($event) {
      this.getAllFamilyResult.forEach((item) => {
        item.check = $event.target.checked;
      });
      this.getAllFamilyResult = [...this.getAllFamilyResult];
      this.$forceUpdate();
    },
    async init() {
      //初始化
      this.step = "1";
      this.remoteDataMessage = "資料讀取中，請稍候...";
      this.custsOfAgntIsLoading = true;
      const result = await getAllHouseholderBySales(
        this.$store.state.userInfo.id,
        this.$store.getters.IsBankUser
      );
      // const result = mock__getAllHouseholderBySales;
      if (result.header && result.header.status == "200") {
        this.getAllHouseholderBySalesResult = result.data;
      } else {
        this.$toast.info({ title: "執行失敗", timeOut: "10000" });
      }
      this.remoteDataMessage = "無任何家戶";
      this.custsOfAgntIsLoading = false;
      this.registerHanlink(); // for 難字更新
    },
    async doSearch() {
      if (this.keyword === "") {
        this.isSearch = "D";
        this.updateAllHolderSearchData([]);
        return;
      }
      this.isSearch = "S";
      this.getFamilyMemberByconditionResult = [];
      this.remoteDataMessage = "資料讀取中，請稍候...";
      this.custsOfAgntIsLoading = true;
      const result = this.$store.getters.IsBankUser
        ? await getFamilyMemberByConditionBnk(
            this.$store.state.userInfo.id,
            this.keyword
          )
        : await getFamilyMemberBycondition(
            this.$store.state.userInfo.id,
            this.keyword
          );
      // const result = mock__getFamilyMemberBycondition; //假搜尋結果(關鍵字為：小)
      if (result.header && result.header.status == "200" && result.data) {
        this.getFamilyMemberByconditionResult = result.data;
        this.updateAllHolderSearchData(result.data);
      } else {
        this.getFamilyMemberByconditionResult = [];
        this.updateAllHolderSearchData([]);
      }
      this.remoteDataMessage = "查無歸戶資訊，請確認您輸入之資料是否正確";
      this.custsOfAgntIsLoading = false;
      this.registerHanlink(); // for 難字更新
    },
    cleanSearch() {
      this.keyword = "";
      this.isSearch = "D";
      this.init();
    },
    changeCoverMask(item){
      this.getAllHouseholderBySalesResult.forEach( otherItem => {
        if(otherItem != item){
            otherItem.namecovermask = false
        }
      });
    },

    //將搜尋到的家戶成員姓名合併成字串
    addFamilyName(familyNameList) {
      let str = "";
      familyNameList.forEach((familyItem, familyIndex) => {
        str +=
          familyIndex + 1 == familyNameList.length
            ? this.truncate(familyItem, 12)
            : this.truncate(familyItem, 12) + "、";
      });
      let result = this.truncate(str, 30);
      return result[result.length - 4] == "、" &&
        result[result.length - 1] == "."
        ? result.substring(0, result.length - 4) + "..."
        : result;
    },
    //步驟一點擊卡片，至步驟二
    async toStep2(card) {
      this.step = "2";
      const result = await getAllFamily(
        card.agidno,
        card.csidno,
        this.$store.getters.IsBankUser
      );
      // const result = mock__getAllFamily;
      this.getAllFamilyResult = result.data;
      this.getAllFamilyResult.forEach((item) => {
        item.check = true;
      });
      this.registerHanlink();
    },
    //步驟二點擊重選家戶，回到步驟一
    toStep1() {
      this.step = "1";
      this.getAllFamilyResult = [];
      this.isSearch = "D";
      this.keyword = "";
      this.registerHanlink();
    },
    //按下確定匯入，將匯入的列表更新父層
    toImport() {
      let APC_IDList = [];
      this.$store.commit("set_allRiskObj", ""); //舊有家戶 riskObj 清空
      let importList = this.getAllFamilyResult.filter((item) => {
        item.insured_name = item.name;
        item.insured_id = item.csidno || "";
        item.insured_gender = item.sex || "1";
        item.familyid = item.familyid;
        item.insured_birthday =
          !item.birthday || item.birthday == ""
            ? ""
            : moment(item.birthday + "").format("YYYY-MM-DD");
        item.insured_age = item.age + "";
        item.job_cat = "";
        const obj = {
          APC_ID: item.insured_id,
          BRDY: item.insured_birthday,
        };
        APC_IDList.push(obj);
        return item.check;
      });
      // 投資型商品判斷商品風險屬性顯示文字
      this.$mfAPI
        .MFA1_0100__getKYCInfo({
          APC_IDs: APC_IDList,
        })
        .then((res) => {
          this.$store.commit("set_kycRiskObj", ""); // 此份建議書風險屬性清空
          this.$emit("riskObjList", res); //  匯入家戶一開始init 資料
          this.$store.commit("set_allRiskObj", res); // 匯入家戶所有 riskObj，因應切換別的tab存資料
        })
        .catch((error) => {
          this.$toast.info({
            title:
              "風險屬性檢核異常，您可以稍後再重新確認",
          });
        });
      this.$store.commit("update_queryDetailTarget", {
        is_crm: "1",
        insured_id: importList[0].familyid,
        prod_idx: "",
        familyid: importList[0].familyid,
      });
      this.$emit("importList", importList);
    },
  },
  watch: {
    open() {
      this.keyword = "";
      this.isSearch = "D";
      this.step = "1";
      this.getAllFamilyResult = [];
    },
    getFamilyMemberByconditionResult: {
      handler() {
        this.$forceUpdate();
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
#searchclear {
  position: absolute;
  right: 40px;
  top: 16px;
  bottom: 0;
  margin-right: 58px;
  cursor: pointer;
  font-size: 15px;
  color: #048f3a;
  text-decoration: underline;
}
.card {
  flex: 1;
  margin-bottom: 10px;
  border-radius: 8px;
  padding: 10px 20px;
  border: 1px solid #989ca2;
  box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.15);

  .desc {
    vertical-align: middle;
    margin-right: 10px;
  }
}
.pre-formatted {
  white-space: pre;
}
.cardList {
  padding: 10px 20px 10px 20px;
  margin-right: 13px;
  margin-bottom: 20px;
  margin-left: 0px;
}
.cardCon {
  border-radius: 8px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);
  border: solid 1px #989ca2;
  background-color: #ffffff;
}
.list /deep/ .tooltip .tooltip-text,
.list /deep/ .tooltip .tooltip-text strong {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 400;
}
</style>
